// ssr-request-logger.initializer.ts
import {
    EnvironmentProviders,
    inject,
    provideAppInitializer,
    TransferState,
} from "@angular/core";

interface SSRStoreEntry {
    u: string;
    s: number;
    st: string;
    b: unknown;
    h: Record<string, string[]>;
    rt: string;
}

export function provideSsrRequestLogger(): EnvironmentProviders {
    return provideAppInitializer(() => {
        const transferState = inject(TransferState);
        // eslint-disable-next-line
        const store = (transferState as any)["store"] as Record<string, SSRStoreEntry>;

        if (!store || typeof store !== "object") {
            return;
        }

        const entries = Object.entries(store).filter(([key, value]) =>
            key !== "__nghData__" && value?.u,
        );

        if (!entries.length) {
            return;
        }

        // const urlCount = entries.reduce<Record<string, number>>((acc, [, value]) => {
        //     acc[value.u] = (acc[value.u] ?? 0) + 1;
        //     return acc;
        // }, {});

        // const duplicates = Object.entries(urlCount).filter(([, count]) => count > 1);
        // // eslint-disable-next-line no-console
        // console.groupCollapsed(`[SSR] ${entries.length} request(s) made on server:`);
        //
        // if (duplicates.length) {
        //     // eslint-disable-next-line no-console
        //     console.group(`⚠️ ${duplicates.length} duplicated request(s):`);
        //     duplicates.forEach(([url, count]) => console.warn(`${count}x ${url}`));
        //     // eslint-disable-next-line no-console
        //     console.groupEnd();
        // }

        entries.forEach(([, value]) => {
            const icon = value.s < 400 ? "✓" : "✘";
            // const isDuplicate = urlCount[value.u] > 1;
            // eslint-disable-next-line no-console
            console.groupCollapsed(`${icon}${value.u} (${value.s} ${value.st})`);
            // eslint-disable-next-line no-console
            console.log("body:", value.b);
            if (Object.keys(value.h ?? {}).length) {
                // eslint-disable-next-line no-console
                console.log("headers:", value.h);
            }
            // eslint-disable-next-line no-console
            console.groupEnd();
        });
        // eslint-disable-next-line no-console
        console.groupEnd();
    });
}
